/**
 * Keeps header search triggers' aria-expanded in sync with the Nosto overlay.
 */
const syncSearchTriggers = (expanded) => {
  document.querySelectorAll('[data-header-search-trigger]').forEach((trigger) => {
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });
};

document.addEventListener('bt-search:open', () => {
  syncSearchTriggers(true);
});

document.addEventListener('bt-search:close', () => {
  syncSearchTriggers(false);
});
